/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'Αριθμός προσβάσεων',
    BLACK_FRIDAY_COMISSION_TITLE: 'Προμήθειες της Μαύρης Παρασκευής {0}',
    BLACK_FRIDAY_COMMISSION: 'Προμήθειες της Μαύρης Παρασκευής {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Προμήθειες της Μαύρης Παρασκευής {0}',
    COMISSION_DESCRIPTION: 'Σύνολο που υπολογίζεται τον τρέχοντα μήνα:',
    COMISSION_LAST_MONTH: 'Ομόλογο',
    COMISSION_LAST_TEN: 'Τελευταία {0} ημέρες',
    COMISSION_TITLE: 'Προμήθειες {0} ημέρες:',
    COMMISSION: 'Επιτροπή',
    COMMISSION_COLUMN: 'Επιτροπή (€)',
    DAILY: 'Ημερολόγιο',
    DATE: 'Ημερομηνία',
    FEMALE: 'Γυναίκα',
    FIFTY_DAYS: '50 ημέρες',
    GENDER: 'Φύλο',
    HITS: 'Πρόσβαση {0} ημέρες:',
    HITS_DESCRIPTION: 'Πρόσβαση',
    HOMOLOGOUS: 'Ομόλογο',
    HOMOLOGOUS_LAST_YEAR: 'Προηγούμενο έτος',
    MALE: 'Αρσενικό',
    NAME: 'Όνομα',
    NEW_CUSTOMERS: 'Λογαριασμοί νέων πελατών {0} ημέρες:',
    NEW_CUSTOMERS_ANNIVERSARY: 'Νέοι επετειακοί λογαριασμοί πελατών Prozis',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION:
      'Νέοι λογαριασμοί σε αναμονή παραγγελίας {0} ημέρες:',
    NO_SALES: 'Δεν υπάρχουν πωλήσεις',
    ORDER_PENDING_CUSTOMERS: 'Λογαριασμός σε εκκρεμότητα',
    ORDERED_CUSTOMERS: 'Νέος λογαριασμός πελάτη',
    ORDERS: 'Παραγγελίες {0} ημέρες:',
    ORDERS_DESCRIPTION: 'Πληρώθηκε τους τελευταίους 6 μήνες',
    ORDERS_DETAIL_DESCRIPTION: 'Χρεώσεις σε αναμονή πληρωμής {0} ημέρες:',
    ORDERS_PAY: 'Καταβληθείσες χρεώσεις',
    ORDERS_PENDING: 'Ανεξόφλητες χρεώσεις',
    PERCENTAGE: 'Ποσοστό',
    PRODUCT_CATEGORY: 'Ιεραρχία',
    PRODUCT_COLUMN: 'Προϊόν',
    QT_COLUMN: 'Ποσότητα',
    QUANTITY: 'Ποσότητα',
    SALES: 'Πωλήσεις',
    SALES_DESCRIPTION: 'Τρέχων μήνας',
    SALES_PRODUCT: 'Πωλήσεις ανά ιεραρχία προϊόντων',
    TEN_DAYS: '10 ημέρες',
    THIRTEEN_DAYS: '30 ημέρες',
    TOP_COMMISSION_TITLE: 'Κορυφαία παραγγελία προϊόντων',
    TOP_DESCRIPTION: 'Τρέχων μήνας',
    TOP_GENDER_DESCRIPTION: 'Τελευταία {0} ημέρες',
    TOP_GENDER_TITLE: 'Κορυφαίες πωλήσεις ανά φύλο',
    TOP_TITLE: 'Κορυφαία άρθρα με τις καλύτερες πωλήσεις',
    TWENTY_DAYS: '20 ημέρες',
    UPDATED_AT: 'Ενημερωμένο {0}',
    VALUE: 'Αξία'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Τα δεδομένα λείπουν',
    EMPTY_TITLE: 'Δεν υπάρχουν αποτελέσματα'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
